export interface IdmTablePagingProps {
  page: number;
  totalPages: number;
  handlePagination: (page: number) => void;
}

export default function IdmTablePaging({
  page,
  totalPages,
  handlePagination,
}: IdmTablePagingProps) {
  return (
    <div className="">
      <div className="flex justify-center py-4">
        {page !== 1 && (
          <button
            type="button"
            aria-label="Previous page"
            className="my-0 mx-1 h-8 w-8 rounded border-0 bg-transparent font-semibold shadow hover:bg-darker-red dark:bg-gray dark:text-black dark:hover:bg-darker-red dark:hover:text-white"
            onClick={() => handlePagination(page - 1)}
          >
            &lt;
          </button>
        )}

        {totalPages > 1 && (
          <button
            type="button"
            className={` my-0 mx-1 h-8 w-8 rounded border-0 font-semibold shadow hover:bg-darker-red dark:hover:bg-darker-red dark:hover:text-white ${
              page === 1
                ? 'bg-darker-red text-white'
                : 'bg-transparent dark:bg-gray dark:text-black'
            }`}
            onClick={() => handlePagination(1)}
          >
            1
          </button>
        )}

        {page > 3 && <div className="my-0 mx-1 w-4">...</div>}

        {page === totalPages && totalPages > 3 && (
          <button
            type="button"
            className="my-0 mx-1 h-8 w-8 rounded border-0 bg-transparent font-semibold shadow hover:bg-darker-red dark:bg-gray dark:text-black dark:hover:bg-darker-red dark:hover:text-white"
            onClick={() => handlePagination(page - 2)}
          >
            {page - 2}
          </button>
        )}

        {page > 2 && (
          <button
            type="button"
            className="my-0 mx-1 h-8 w-8 rounded border-0 bg-transparent font-semibold shadow hover:bg-darker-red dark:bg-gray dark:text-black dark:hover:bg-darker-red dark:hover:text-white"
            onClick={() => handlePagination(page - 1)}
          >
            {page - 1}
          </button>
        )}

        {page !== 1 && page !== totalPages && (
          <button
            type="button"
            className=" my-0 mx-1 h-8 w-8 rounded border-0 bg-darker-red font-semibold text-white shadow hover:bg-darker-red dark:hover:bg-darker-red dark:hover:text-white"
            onClick={() => handlePagination(page)}
          >
            {page}
          </button>
        )}

        {page < totalPages - 1 && (
          <button
            type="button"
            className="my-0 mx-1 h-8 w-8 rounded border-0 bg-transparent font-semibold shadow hover:bg-darker-red dark:bg-gray dark:text-black dark:hover:bg-darker-red dark:hover:text-white"
            onClick={() => handlePagination(page + 1)}
          >
            {page + 1}
          </button>
        )}

        {page === 1 && totalPages > 3 && (
          <button
            type="button"
            className="my-0 mx-1 h-8 w-8 rounded border-0 bg-transparent font-semibold shadow hover:bg-darker-red dark:bg-gray dark:text-black dark:hover:bg-darker-red dark:hover:text-white"
            onClick={() => handlePagination(page + 2)}
          >
            {page + 2}
          </button>
        )}

        {page < totalPages - 2 && <div className="my-0 mx-1 w-4">...</div>}

        <button
          type="button"
          className={`my-0 mx-1 h-8 w-8 rounded border-0 font-semibold shadow hover:bg-darker-red dark:hover:bg-darker-red dark:hover:text-white ${
            page === totalPages
              ? 'bg-darker-red text-white'
              : 'bg-transparent dark:bg-gray dark:text-black'
          }`}
          onClick={() => handlePagination(totalPages)}
        >
          {totalPages}
        </button>

        {page !== totalPages && (
          <button
            type="button"
            aria-label="Next page"
            className="my-0 mx-1 h-8 w-8 rounded border-0 bg-transparent font-semibold shadow hover:bg-darker-red dark:bg-gray dark:text-black dark:hover:bg-darker-red dark:hover:text-white"
            onClick={() => handlePagination(page + 1)}
          >
            &gt;
          </button>
        )}
      </div>
    </div>
  );
}
